import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {useStore} from "../../../hooks/useStore";
import {codPaymentReferenceCodeStatuses} from "../../../constants/constants";

const CodPaymentRefCodeStatusFilter = ({
    value,
    onChange,
    showLabel = true,
    showAllOption = true,
    mode = undefined,
    selectMarginBottom = "20px",
    allowClear = false,
    loading,
    disabled
}) => {
    const {t} = useTranslation();
    const stores = useStore();
    if (stores.meStore.auth.cities?.length == 1) {
        showAllOption = false;
        value = stores.meStore.auth.cities[0];
    }
    return (
        <React.Fragment>
            {showLabel && <h5>{"Durum"}</h5>}
            <SelectField
                showSearch
                value={value}
                data-testid="codPaymentRefCodeStatus"
                mode={mode}
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
                loading={loading}
                disabled={disabled || loading}
            >
                {showAllOption ? (
                    <SelectField.Option data-testid="status_option" value={"all"}>
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                ) : (
                    <></>
                )}
                {codPaymentReferenceCodeStatuses.map(status => (
                    <SelectField.Option
                        data-testid="status_option"
                        value={status.value}
                        key={status.value}
                    >
                        {t(`codPaymentReferenceCodeStatuses.${status.translation_key}`, {
                            ns: "codPayment"
                        })}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default CodPaymentRefCodeStatusFilter;
